import type { Account, AccountEntity, Card, CardsEntity } from '@shared/api';

export class AccountUtils {
  static decodeAccount = (account: Account): AccountEntity => {
    const value = { ...account, cards: this.sortCardByStatus(account.cards) };
    const result = {
      id: value?.accountId,
      currency: value?.currency,
      displayName: value?.displayName,
      availableToSpend: value.limits ? value.limits.available : undefined,
      currentSpend: value.limits ? value.limits.spent : undefined,
      limit: value.limits ? value.limits.creditLimit : undefined,
      validOperations: value.claims ? [...value.claims].map(this.convertClaim) : null,
      product: {
        code: value.productCode ? value.productCode : undefined,
        name: value.productName ? value.productName : undefined,
        isDarkCardColor: value.image ? value.image.description !== 'light' : undefined,
        cardImageUrl: value.image ? value.image.data : undefined,
      },
      supplementCards: [],
    } as unknown as AccountEntity;

    value.cards.forEach((item) => {
      if (!result.mainCard && item.cardType === 'Main') result.mainCard = this.convertCard(item);
      else result.supplementCards.push(this.convertCard(item));
    });
    if (!result.mainCard) result.mainCard = result.supplementCards.shift()!;

    return result;
  };

  static sortCardByStatus = (cards: Card[]) => {
    return cards.slice().sort((a, b) => {
      if (a.cardStatus === 'Blocked' && b.cardStatus !== 'Blocked') return 1;
      if (a.cardStatus !== 'Blocked' && b.cardStatus === 'Blocked') return -1;
      return 0;
    });
  };

  static convertClaim = (claim: string) => {
    switch (claim) {
      case 'BlockCard':
        return 'Block';
      case 'ChangePin':
        return 'PinReminder';
      case 'PinRequest':
        return 'PinReminder';
      case 'CreditLimit':
        return 'ChangeLimit';
      case 'RequestSupplement':
        return 'Supplementary';
      default:
        return claim;
    }
  };

  static convertCard = (card: Card): CardsEntity => ({
    id: card.cardId,
    cardHolder: card.cardHolder,
    number: card.cardNumber,
    status: card.cardStatus,
    type: 0,
    cardType: card.cardType,
    validThru: null,
    mobile: card.mobile,
    contactPhoneNumber: card.contactPhoneNumber,
    securePhoneNumber: card.securePhoneNumber,
    cardDesignImageUrl: card.cardDesignImageUrl,
  });
}
